import { colors, makeStyles } from "@material-ui/core";

export const useStyles = makeStyles(
  (theme) => ({
    root: {
      marginTop: "10%",
      padding: 0,
    },

    contentWrapper: {
      position: "relative",
      boxShadow: theme.shadows[2],
      backgroundColor: theme.palette.common.white,
      padding: "40px 60px 40px 60px",
      borderRadius: 2,

      [theme.breakpoints.down("xs")]: {
        padding: "40px 20px 30px 20px",
      },

      "& .errorWrapper": {
        display: "block",
        fontSize: "0.8rem",
        fontWeight: theme.typography.fontWeightLight,
        color: theme.palette.error.main,
      },

      "& .flatButton": {
        display: "inline-block",
        fontSize: 14,
        fontWeight: theme.typography.fontWeightMedium,
        marginRight: 40,
        marginBottom: 2,

        cursor: "pointer",
        color: colors.grey[600],
      },

      "& .inlineForm": {
        [theme.breakpoints.down("xs")]: {
          flexWrap: "wrap",
        },

        "& .inlineFormElement": {
          width: "100%",

          [theme.breakpoints.down("xs")]: {
            marginBottom: 16,
          },
        },
      },
    },

    subHeader: {
      fontWeight: theme.typography.fontWeightLight,
      textAlign: "left",

      "& span": {
        fontSize: 14,
      },

      "& p": {
        fontSize: 13,
        fontStyle: "italic",
        color: colors.grey[700],
      },
    },
  }),
  {
    name: "create-business-style",
    flip: null,
  }
);
